import React from 'react';
import { MessageCircle, AlertTriangle } from 'lucide-react';

const DossierMessaging = () => {
  console.log('EMERGENCY: DossierMessaging desactive pour eviter conflits Firestore');

  return (
    <div className="bg-white rounded-lg shadow-md flex flex-col h-[600px]">
      {/* Header d'urgence */}
      <div className="p-4 border-b bg-red-50 border-red-200">
        <div className="flex items-center space-x-3">
          <AlertTriangle className="w-6 h-6 text-red-600" />
          <h2 className="text-xl font-semibold text-red-800">
            Messagerie Temporairement Désactivée
          </h2>
        </div>
        <p className="text-sm text-red-600 mt-2">
          Correction des erreurs Firestore en cours...
        </p>
      </div>

      {/* Zone centrale */}
      <div className="flex-grow flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <MessageCircle className="w-24 h-24 text-gray-300 mx-auto mb-6" />
          
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            Interface Temporairement Indisponible
          </h3>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-center space-x-2 mb-2">
              <AlertTriangle className="w-5 h-5 text-yellow-600" />
              <span className="font-medium text-yellow-800">Problème Détecté</span>
            </div>
            <p className="text-sm text-yellow-700">
              Conflits de listeners Firestore causant des erreurs INTERNAL ASSERTION FAILED
            </p>
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-medium text-blue-800 mb-2">Solution en cours :</h4>
            <ul className="text-sm text-blue-700 text-left space-y-1">
              <li>• Élimination des listeners multiples</li>
              <li>• Stabilisation de la base de données</li>
              <li>• Tests des vignettes de notification</li>
            </ul>
          </div>
          
          <p className="text-sm text-gray-600 mt-6">
            <strong>Utilisation alternative :</strong><br />
            Utilisez UnifiedMessageModal depuis l'interface admin
          </p>
        </div>
      </div>

      {/* Footer informatif */}
      <div className="p-4 border-t bg-gray-50">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span>Status: Désactivé pour maintenance</span>
          <span>Mode: Emergency Recovery</span>
        </div>
      </div>
    </div>
  );
};

export default DossierMessaging;